const zeroWidthSpace = '\u200B';
export function allowUrlLinebreaks(url) {
    return url.replace(/\//g, `${zeroWidthSpace}/${zeroWidthSpace}`);
}
// matches app/models/concerns/thumbable.rb in admin-panel-api
const thumbnailSize = {
    VARIANT_LARGE_WEBP: [2000, 2000],
    VARIANT_MEDIUM_WEBP: [980, 680],
    VARIANT_SMALL_WEBP: [760, 350],
    VARIANT_THUMBNAIL_PNG: [300, 300],
    VARIANT_THUMBNAIL_JPEG: [300, 300],
    VARIANT_THUMBNAIL_WEBP: [140, 140],
    VARIANT_THUMBNAIL_PNG_600: [600, 600],
};
const thumbnailsToUse = [
    'VARIANT_LARGE_WEBP',
    'VARIANT_MEDIUM_WEBP',
    'VARIANT_SMALL_WEBP',
    'VARIANT_THUMBNAIL_PNG_600',
    'VARIANT_THUMBNAIL_PNG',
    'VARIANT_THUMBNAIL_WEBP',
];
export const THUMBNAIL_SIZE = {
    Large: 2000,
    Medium: 980,
    Small: 760,
    Tiny: 140,
};
export function pickThumbnail(thumbnails, targetWidth = THUMBNAIL_SIZE.Large, targetHeight = targetWidth) {
    const targetArea = targetWidth * targetHeight;
    return thumbnailsToUse
        .map(key => {
        const thumbnailArea = thumbnailSize[key][0] * thumbnailSize[key][1];
        const rating = Math.abs(targetArea - thumbnailArea);
        const result = [rating, thumbnails[key]];
        return result;
    })
        .filter(it => it[1] !== undefined)
        .reduce((best, it) => {
        return best[0] < it[0] ? best : it;
    })[1];
}
const cdnHost = typeof CDN_HOST === 'string' ? CDN_HOST : process.env.REACT_APP_CND_URL;
export function generateThumbnailUrl(thumbnails, targetWidth, targetHeight) {
    return `${cdnHost}/pubtool-images/${pickThumbnail(thumbnails, targetWidth, targetHeight)}`;
}
